import { render, staticRenderFns } from "./CloudClassCenter.vue?vue&type=template&id=3c88697b&scoped=true&"
import script from "./CloudClassCenter.vue?vue&type=script&lang=js&"
export * from "./CloudClassCenter.vue?vue&type=script&lang=js&"
import style0 from "./CloudClassCenter.vue?vue&type=style&index=0&id=3c88697b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c88697b",
  null
  
)

export default component.exports